var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-leilao-container"},[_c('div',{staticClass:"ev2-body leilao-dash realizacao historico"},[_c('log-leilao')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }